import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { GoogleMapUrl } from '@bd/bdcore-utilities';
import numeral from 'numeral';
import { UnderdogCenter } from '../../helpers/UIElements';
import AccordionToggle from '../../components/AccordionToggle';
import icons from '../../components/IconsList';

const styles = css`
  @media (min-width: 992px) {
    margin-bottom: 130px;
  }
  p {
    margin-bottom: 0;
  }
  li:nth-child(odd) {
    background-color: #f7f6f6;
  }
  .LotContent_wrapper {
    padding: 20px;
  }
  .CommunityLots_title {
    display: none;
    @media(min-width: 992px) {
      border-bottom: 0;
      text-transform: uppercase;
      background-color: transparent;
      background-image: none;
      font-weight: 700;
      font-size: 21px;
      color: #212121;
      letter-spacing: 5px;
      text-align: center;
      line-height: 32px;
      position: relative;
      display: inherit;
      flex-direction: column;
      padding: 0 20px;
    }
  }
`;

function LotResults({ homeLots }) {
  return (
    <div className={styles}>
      <div id="lots" className="CommunityLots_scrollTarget">
        <AccordionToggle
          openOnId="lots"
          button={({ contentVisible }) => (
            <div className="DetailsSection_btn d-lg-none" role="button" tabIndex={0}>
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Community Lots</h3>
            </div>
          )}
        >
          <div className="container">
            <UnderdogCenter className="d-none d-lg-block">
              <h3 className="CommunityLots_title">Community Lots</h3>
            </UnderdogCenter>
            <ul className="list-unstyled">
              {
                orderBy(homeLots, 'lot', 'asc').map(item => (
                  <li key={item._id} className="d-flex row LotContent_wrapper">
                    <div className="col-5">
                      {
                        get(item, 'lot') &&
                        <p><b>Lot# {get(item, 'lot')}</b></p>
                      }
                      {
                        get(item, 'address.streetAddress') &&
                        <p>{get(item, 'address.streetAddress')}</p>
                      }
                      {
                        get(item, 'address.addressLocality') && get(item, 'address.addressRegion') &&
                        <p>{get(item, 'address.addressLocality')}, {get(item, 'address.addressRegion')}</p>
                      }
                    </div>
                    <div className="col-4">
                      {
                        get(item, 'lotSize') &&
                        <p><b>Lot Size: </b>{numeral(get(item, 'lotSize')).format('0,0')} SQFT</p>
                      }
                      {
                        <p><b>Lot Price: </b>{get(item, 'price') > 0 ? numeral(get(item, 'price')).format('$0,0') : 'Call for Pricing'}</p>
                      }
                      {
                        get(item, 'status') &&
                        <p><b>Status: </b>{get(item, 'status')}</p>
                      }
                    </div>
                    <div className="col-3 text-right">
                      {
                        <a href={GoogleMapUrl(item)} target="_blank" rel="noopener noreferrer">
                          <span><img src={get(icons, 'mapPin')} className="mr-2" alt="Card Map Pin" height="25px" width="auto" /><b> Google Map</b></span>
                        </a>
                      }
                    </div>
                  </li>
                ))
              }
            </ul>
          </div>
        </AccordionToggle>
      </div>
    </div>
  );
}

LotResults.propTypes = {
  homeLots: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default LotResults;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/LotResults.js